import { Component, Input } from '@angular/core';
import { Device } from '@era/locations-sdk';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'era-device-swapped-current-action-bar-ui',
  templateUrl: './device-swapped-current-action-bar.component.html',
  styleUrls: ['./device-swapped-current-action-bar.component.scss'],
  imports: [RouterLink],
})
export class DeviceSwappedCurrentActionBarComponent {
  @Input() public allowSpare = false;
  @Input() public allowUnavailable = false;

  @Input() public device: Device;
}
